var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CssBaseline = void 0;
var CssBaseline_1 = __importDefault(require("./CssBaseline"));
exports.CssBaseline = CssBaseline_1.default;
exports.default = CssBaseline_1.default;
//# sourceMappingURL=index.js.map